import i18next from 'i18next';

i18next.addResources('es', 'projects', {
  activity: 'Proyectos financiados por los bancos de la Alianza relevantes para la integración de ALC',
  title: 'Proyectos',
  showMap: 'Mostrar mapa',
  showList: 'Mostrar grilla',
  textMapFilter: 'Buscar mientras muevo en el mapa'
});

i18next.addResources('en', 'projects', {
  activity: 'Projects financed by Alliance banks relevant to LAC integration',
  title: 'Projects',
  showMap: 'Show map',
  showList: 'Show grid',
  textMapFilter: 'Search while I move on the map'
});

i18next.addResources('pt', 'projects', {
  activity: 'Projetos financiados pelos bancos da Aliança relevantes para a integração da ALC',
  title: 'Projetos',
  showMap: 'Mostrar mapa',
  showList: 'Mostrar grade',
  textMapFilter: 'Buscar enquanto me movo no mapa'
});
